import { createStore } from "jotai";

export const XStore = createStore();
